/**
 * Judge.me preview badge — hide review count number, keep "reviews" label only.
 */
(function () {
  function normalizeReviewLabel(text) {
    let label = text
      .replace(/\(\s*[\d,.]+\s*reviews?\s*\)/gi, 'reviews')
      .replace(/[\d,.]+\s*reviews?/gi, 'reviews')
      .replace(/\d+\.?\d*\s*out\s+of\s+5\s+stars?/gi, '')
      .replace(/^\d+\.?\d*\s*/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!/reviews?/i.test(label)) {
      label = 'reviews';
    }

    return label;
  }

  function stripReviewCountFromBadgeText(el) {
    if (!el) return;

    const enhanced = el.querySelector('.enhanced-judgeme-badge');
    if (enhanced) {
      const reviewCount = enhanced.querySelector('.review-count');
      if (reviewCount) {
        reviewCount.textContent = 'reviews';
      }
      const ratingDisplay = enhanced.querySelector('.rating-display');
      if (ratingDisplay) {
        ratingDisplay.remove();
      }
      el.dataset.reviewLabelNormalized = 'true';
      return;
    }

    const label = normalizeReviewLabel(el.textContent);
    if (el.textContent.trim() === label && el.dataset.reviewLabelNormalized === 'true') return;

    el.textContent = label;
    el.dataset.reviewLabelNormalized = 'true';
  }

  function processJudgeMeBadges(root) {
    root.querySelectorAll('.jdgm-prev-badge__text').forEach(stripReviewCountFromBadgeText);
  }

  function init() {
    processJudgeMeBadges(document);
  }

  document.addEventListener('DOMContentLoaded', init);
  [500, 1200, 2500, 4000].forEach(function (delay) {
    setTimeout(init, delay);
  });

  document.querySelectorAll('.badge-wrapper').forEach(function (wrapper) {
    new MutationObserver(function () {
      processJudgeMeBadges(wrapper);
    }).observe(wrapper, { childList: true, subtree: true, characterData: true });
  });
})();
